import {StoreNamespace} from "@/globals/StoreNamespaceGlobal";
import {RootState} from '@/store'
import {SearchState} from '@/store/modules/search/index'
import {RequestPayload, ServiceApi} from '@payroll/optimus-common'
import {ActionTree} from 'vuex'

export const actions: ActionTree<SearchState, RootState> = {

  searchEmployers: ({commit, dispatch, state, rootGetters}: any, requestPayload: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('searchEmployers')
      .setRequestBody(requestPayload.requestBody)
      .post(requestPayload.requestorCallback)
  },

  searchEmployerRegistrations: ({commit, dispatch, state, rootGetters}: any, requestPayload: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('searchEmployerRegistrations')
      .setRequestBody(requestPayload.requestBody)
      .post(requestPayload.requestorCallback)
  },

  getEmployerRegistrationDetails: ({commit, dispatch, state, rootGetters}: any, {pathVariable, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getEmployerRegistrationDetails')
      .setPathVariable(pathVariable)
      .get(requestorCallback)
  },

  deleteEmployerRegistration: ({commit, dispatch, state, rootGetters}: any, requestPayload: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('deleteEmployerRegistration')
      .setPathVariable(requestPayload.pathVariable)
      .put(requestPayload.requestorCallback)
  },

  approveRegistrations: ({commit, dispatch, state, rootGetters}: any, {requestBody, requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('approveRegistrations')
      .setRequestBody(requestBody)
      .post(requestorCallback)
  },

  searchCustomerServiceMessages: ({commit, dispatch, state, rootGetters}: any, requestPayload: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('searchCustomerServiceMessages')
      .setRequestBody(requestPayload.requestBody)
      .post(requestPayload.requestorCallback)
  },

  updateCustomerServiceMessage: ({rootGetters}: any, requestPayload: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('updateCustomerServiceMessage')
      .setPathVariable(requestPayload.pathVariable)
      .setRequestBody(requestPayload.requestBody)
      .put(requestPayload.requestorCallback)
  },

  downloadEmployerRegistration: ({commit, dispatch, state, rootGetters}: any, requestPayload: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('downloadRegistrationFormReport')
      .setPathVariable(requestPayload.pathVariable)
      .get(requestPayload.requestorCallback)
  },

  getAttachmentContactMe: ({commit, dispatch, state, rootGetters}: any, requestPayload: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getAttachmentContactMe')
      .setPathVariable(requestPayload.pathVariable)
      .get(requestPayload.requestorCallback)
  },

  getEmployerRegistrationStatuses: ({rootGetters}: any, requestPayload: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getEmployerRegistrationStatuses')
      .get(requestPayload.requestorCallback)
  },

  updateEmployer: ({rootGetters}: any, requestPayload: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('updateEmployer')
      .setRequestBody(requestPayload.requestBody)
      .put(requestPayload.requestorCallback)
  },

  getCustomerServiceStatuses: ({rootGetters}: any, requestPayload: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getCustomerServiceStatuses')
      .get(requestPayload.requestorCallback)
  },

  getCustomerServiceSubjects: ({rootGetters}: any, requestPayload: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getCustomerServiceSubjects')
      .get(requestPayload.requestorCallback)
  },

  getPortalTypes: ({rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getPortalTypes')
      .get(requestorCallback)
  },

  getUserTypes: ({rootGetters}: any, {requestorCallback}: RequestPayload) => {
    new ServiceApi()
      .setToken(rootGetters[StoreNamespace.ACCESS_TOKEN_GETTER])
      .setRequestName('getUserTypes')
      .get(requestorCallback)
  }
}
